import React, { Component } from 'react';

export default class DatasetSelector extends Component {

  constructor(props){
	super(props)
	this.state = {
		appURL: "https://patstat.org/VPWeb/VPWebServer.php",
		datasetID: 3
	}
	this.UpdateDataset = this.UpdateDataset.bind(this)
}

componentDidMount(){
}
UpdateDataset(){
	//pass appURL and datasetID up to App
	let appURL = document.getElementById("appURL").value
	let datasetID = document.getElementById("datasetID").value
	this.props.callbackFromParent(appURL, datasetID)
}
  render() {
	const {
		datasetID,
		appURL
	} = this.state;
	return (
	  <div className="DatasetInputBox">
	  	<label htmlFor="appURL">URL: </label><input id="appURL" type="text" defaultValue={appURL}></input>
	  	<label htmlFor="datasetID">Dataset ID: </label><input id="datasetID" type="number" defaultValue={datasetID}></input>
		  <button onClick={() => this.UpdateDataset()}>Go</button>
	  </div>
	);
  }
}
